<script setup lang="ts">
    import Lead from '@/app/crm/models/Lead';
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    interface Props extends FormInputProps {
        withCreateButton?: boolean;
    }

    const emit = defineEmits(['selected']);

    const select = ref(null);
    const props = withDefaults(defineProps<Props>(), {
        withCreateButton: false,
    });
    const inputData: FormInputData = useFormInput(props);
    const displayCreateButton = computed(() => props.withCreateButton && !inputData?.model.value);

    useListen('crm:lead:updated', (lead) => {
        if (inputData.model.value && lead.is(inputData.model.value)) {
            inputData.model.value = lead;
        }
    });
    useListen('crm:lead:deleted', (uuid) => {
        if (inputData.model?.value?.getId() === uuid) {
            inputData.model.value = null;
        }
    });

    const selectLead = (lead: Lead | null) => {
        inputData.model.value = lead;
        emit('selected', lead);
    };
</script>

<template>
    <FormElement
        :input-data="inputData"
        @label-clicked="select?.show()"
    >
        <SelectLead
            ref="select"
            :initial-value="inputData.model.value"
            :with-create-button="displayCreateButton"
            @selected="selectLead"
        >
            <template
                v-if="inputData.model.value"
                #button
            >
                <div class="flex items-center h-full space-x-3">
                    <a
                        href="#"
                        class="text-xs text-gray-600 transition-all cursor-pointer hover:text-branding-rich-black"
                        :data-tooltip="$t('actions.edit')"
                        @click.stop.prevent="inputData.model.value.edit()"
                    >
                        <i class="fa-regular fa-pencil" />
                    </a>
                    <a
                        href="#"
                        class="text-sm text-gray-600 transition-all cursor-pointer hover:text-branding-rich-black"
                        :data-tooltip="$t('actions.unselect')"
                        @click.stop.prevent="inputData.model.value = null"
                    >
                        <i class="fa-regular fa-xmark" />
                    </a>
                </div>
            </template>
        </SelectLead>
    </FormElement>
</template>
